import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from "../../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from "../../services/tutorial.service";
import { teamlistData } from "../../actions/index";

function ChangePassword(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setteamlistData);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const [logo, setLogo] = useState();
  const history = useHistory({ forceRefresh: true });
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);

  const onSubmit = (values) => {
    if (values.newpass == values.confirmpass) {
      setDisabled(true);
      const id = toast.loading("Please wait...");
      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([{ cid: cid ,token: token}]),
        },
      };
      //  console.log(values)
      DataService.updatePassword(values, hdr)
        .then((res) => {
          let response = res.data;
          //  console.log(response)
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            let submitdata = [response.data.new];
            toast.success("Password has been changed.", {
              theme: "dark",
              position: "bottom-center",
            });
            history.push(BASE_PATH+'my-profile');
          } else {
            toast.error(response.msg, { theme: "colored" });
          }

          setDisabled(false);
        })
        .catch(() => {
          toast.dismiss(toastContainerId);
          toast.error("Not valid Server Error", { theme: "colored" });
          setDisabled(false);
        });
    } else {
      toast.error("New password & old password does not match ", {
        theme: "colored",
      });
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <input
                            className="form-control"
                            type="hidden"
                            defaultValue={logo}
                            {...register("logo")}
                            id="logo"
                          />

                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="oldpass">
                                    {" "}
                                    Old Password *{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="password"
                                    {...register("oldpass", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.oldpass && (
                                    <p className="text-error">
                                      {errors.oldpass.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="newpass">
                                    {" "}
                                    New Password *{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="password"
                                    {...register("newpass", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.newpass && (
                                    <p className="text-error">
                                      {errors.newpass.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="confirmpass">
                                    {" "}
                                    Confirm Password *{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="password"
                                    {...register("confirmpass", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.confirmpass && (
                                    <p className="text-error">
                                      {errors.confirmpass.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button"
                                type="submit"
                                style={{
                                  borderRadius: "8px",
                                  marginLeft: "14px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
